import { render, staticRenderFns } from "./completed.vue?vue&type=template&id=afe08bd0&scoped=true"
import script from "./completed.vue?vue&type=script&lang=js"
export * from "./completed.vue?vue&type=script&lang=js"
import style0 from "./completed.vue?vue&type=style&index=0&id=afe08bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe08bd0",
  null
  
)

export default component.exports